export const getPriceLabel = (
  lowestPrice: number | null,
  highestPrice: number | null,
): string => {
  if (lowestPrice === 0 && highestPrice !== null && highestPrice > 0) {
    return `Free - £${highestPrice.toFixed(2)}`;
  }

  if (lowestPrice === 0 && (highestPrice === null || highestPrice === 0)) {
    return 'Free';
  }

  if (highestPrice === null || lowestPrice === highestPrice) {
    return `£${lowestPrice?.toFixed(2)}`;
  }

  return `£${lowestPrice?.toFixed(2)} - £${highestPrice?.toFixed(2)}`;
};

export const formatAddress = (address: string) => {
  if (!address) return null;
  return address.replace(/\r?\n/g, ', ');
};
